module.exports = __webpack_public_path__ + "img/lawyerserve_banner.008c9293.jpg";